module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-01_old-5fcecf9fe09994cd506c42b0f4d20f56.jpg";